import { useState } from 'react';
import { useToggle } from 'react-use';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { isToday } from 'date-fns';
import EventCheckInModal from './modals/EventCheckInModal';
import { getCollectionData, getDocumentData } from 'src/shared/firebase';

export default function EventCheckInButton({ event, checkInCode, disabled, onCheckedIn }) {
  const [entry, setEntry] = useState();
  const [lecture, setLecture] = useState();
  const [showsModal, toggleModal] = useToggle(false);
  const handleClick = async () => {
    try {
      const entriesRef = event.ref.collection('entries');
      if (!navigator.onLine) {
        toast.error('ネットワークがオフラインです。通信環境の良い場所で再度チェックインを行ってください。');
        return;
      }

      // チェックインコードで全エントリーを取得してキャンセル状態をチェック
      const allEntries = await getCollectionData(entriesRef.where('checkInCode', '==', checkInCode));
      
      // キャンセル済エントリーがあるかチェック
      const cancelledEntries = allEntries.filter(_ => _.cancelledAt != null);
      if (cancelledEntries.length > 0) {
        toast.error('キャンセル済です。');
        return;
      }

      const entries = allEntries.filter(_ => _.cancelledAt == null);

      // チェックインコードが見つからない場合
      if (entries.length === 0) {
        toast.error('チェックインコードに誤りがあります。正しいコードを入力して、再度チェックインを行ってください。');
        return;
      }
      
      if (entries.every((_) => _.checkedInAt)) {
        toast.error('既にチェックイン済みです。');
        return;
      }

      const uncheckedInEntries = entries.filter(_ => !_.checkedInAt);
      const entriesWithLecture = await Promise.all(
        uncheckedInEntries.map(async (_) => {
          const [frame] = _.frames;
          const lectureRef = event.ref.collection('lectures').doc(frame.lectureId);
          const _lecture = await getDocumentData(lectureRef);

          return { ..._, lecture: _lecture };
        })
      );
      const entryWithLecture = entriesWithLecture.find(({ lecture }) => {
        const { date } = lecture;
        return !!date && isToday(date.toDate());
      });
      if (!entryWithLecture) {
        toast.error('イベント開催日ではありません。イベント当日に再度チェックインを行ってください。');
        return;
      }
      setEntry(entryWithLecture);
      setLecture(entryWithLecture.lecture);
      toggleModal(true);
    } catch (e) {
      console.error(e);
      toast.error('チェックイン中にエラーが発生しました。申し訳ありませんが再度チェックインを行ってください。');
    }
  };

  return (
    <>
      <Button color="primary" outline disabled={disabled} onClick={handleClick}>
        チェックイン
      </Button>
      {entry && lecture && (
        <EventCheckInModal
          event={event}
          lecture={lecture}
          entry={entry}
          isOpen={showsModal}
          onClickClose={() => toggleModal(false)}
          onCheckedIn={onCheckedIn}
        />
      )}
    </>
  );
}
